export enum DocumentTypeEnum {
  Lead = 'leadDocument',
  Supporting = 'supportingDocument',
}
